{
  "id": "shades-of-purple",
  "name": "Shades of Purple",
  "description": "Bold and vibrant shades of purple theme",
  "colors": {
    "light": {
      "primary": "#B362FF",
      "secondary": "#A599E9",
      "positive": "#57C264",
      "negative": "#FF628C",
      "warning": "#FF9D00",
      "important": "#FF7200",
      "light": "#FFFFFF",
      "dark": "#2D2B55",
      "surface": "#F8F9FA",
      "darksurface": "#1E1E3F",
      "white": "#FFFFFF"
    },
    "dark": {
      "primary": "#B362FF",
      "secondary": "#A599E9",
      "positive": "#57C264",
      "negative": "#FF628C",
      "warning": "#FF9D00",
      "important": "#FF7200",
      "light": "#FFFFFF",
      "dark": "#2D2B55",
      "surface": "#F8F9FA",
      "darksurface": "#1E1E3F",
      "white": "#FFFFFF"
    }
  }
}
